module.exports = __webpack_public_path__ + "static/media/ofuroMatagi.a89f6a3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/adl/ofuroMatagi.png
// module id = 1697
// module chunks = 1